import { render, staticRenderFns } from "./dashboardUserLogList.vue?vue&type=template&id=27a317b8&"
import script from "./dashboardUserLogList.vue?vue&type=script&lang=js&"
export * from "./dashboardUserLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports